import { render } from "./BancontactPayment.vue?vue&type=template&id=31d88ecc"
import script from "./BancontactPayment.vue?vue&type=script&lang=js"
export * from "./BancontactPayment.vue?vue&type=script&lang=js"

import "./BancontactPayment.vue?vue&type=style&index=0&id=31d88ecc&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__